/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateProductDto
 */
export interface UpdateProductDto {
    /**
     * Product SKU (Stock Keeping Unit)
     * @type {string}
     * @memberof UpdateProductDto
     */
    sku?: string;
    /**
     * Product name in Arabic
     * @type {string}
     * @memberof UpdateProductDto
     */
    nameAr?: string;
    /**
     * Product name in English
     * @type {string}
     * @memberof UpdateProductDto
     */
    nameEn?: string;
    /**
     * Product description in Arabic
     * @type {string}
     * @memberof UpdateProductDto
     */
    descriptionAr?: string;
    /**
     * Product description in English
     * @type {string}
     * @memberof UpdateProductDto
     */
    descriptionEn?: string;
    /**
     * Array of product image URLs
     * @type {Array<string>}
     * @memberof UpdateProductDto
     */
    imageUrls?: Array<string>;
    /**
     * Whether product is in stock
     * @type {boolean}
     * @memberof UpdateProductDto
     */
    inStock?: boolean;
    /**
     * Brand code from brand lookup table
     * @type {string}
     * @memberof UpdateProductDto
     */
    brandCode?: string;
    /**
     * Category code from category lookup table
     * @type {string}
     * @memberof UpdateProductDto
     */
    categoryCode?: string;
    /**
     * Sub-brand code from sub-brand lookup table
     * @type {string}
     * @memberof UpdateProductDto
     */
    subBrandCode?: string;
    /**
     * Sub-category code from sub-category lookup table
     * @type {string}
     * @memberof UpdateProductDto
     */
    subCategoryCode?: string;
    /**
     * Product barcode
     * @type {string}
     * @memberof UpdateProductDto
     */
    barcode?: string;
    /**
     * Product prices in different currencies (replaces all existing prices)
     * @type {Array<object>}
     * @memberof UpdateProductDto
     */
    prices?: Array<object>;
    /**
     * Tax rate as percentage (0-100)
     * @type {number}
     * @memberof UpdateProductDto
     */
    taxRate?: number;
    /**
     * Discount rate as percentage (0-100)
     * @type {number}
     * @memberof UpdateProductDto
     */
    discountRate?: number;
    /**
     * Product length in centimeters
     * @type {number}
     * @memberof UpdateProductDto
     */
    length?: number;
    /**
     * Product width in centimeters
     * @type {number}
     * @memberof UpdateProductDto
     */
    width?: number;
    /**
     * Product height in centimeters
     * @type {number}
     * @memberof UpdateProductDto
     */
    height?: number;
    /**
     * Product weight in kilograms
     * @type {number}
     * @memberof UpdateProductDto
     */
    weight?: number;
    /**
     * Whether product is disabled
     * @type {boolean}
     * @memberof UpdateProductDto
     */
    disabled?: boolean;
}

/**
 * Check if a given object implements the UpdateProductDto interface.
 */
export function instanceOfUpdateProductDto(value: object): value is UpdateProductDto {
    return true;
}

export function UpdateProductDtoFromJSON(json: any): UpdateProductDto {
    return UpdateProductDtoFromJSONTyped(json, false);
}

export function UpdateProductDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProductDto {
    if (json == null) {
        return json;
    }
    return {
        
        'sku': json['sku'] == null ? undefined : json['sku'],
        'nameAr': json['nameAr'] == null ? undefined : json['nameAr'],
        'nameEn': json['nameEn'] == null ? undefined : json['nameEn'],
        'descriptionAr': json['descriptionAr'] == null ? undefined : json['descriptionAr'],
        'descriptionEn': json['descriptionEn'] == null ? undefined : json['descriptionEn'],
        'imageUrls': json['imageUrls'] == null ? undefined : json['imageUrls'],
        'inStock': json['inStock'] == null ? undefined : json['inStock'],
        'brandCode': json['brandCode'] == null ? undefined : json['brandCode'],
        'categoryCode': json['categoryCode'] == null ? undefined : json['categoryCode'],
        'subBrandCode': json['subBrandCode'] == null ? undefined : json['subBrandCode'],
        'subCategoryCode': json['subCategoryCode'] == null ? undefined : json['subCategoryCode'],
        'barcode': json['barcode'] == null ? undefined : json['barcode'],
        'prices': json['prices'] == null ? undefined : json['prices'],
        'taxRate': json['taxRate'] == null ? undefined : json['taxRate'],
        'discountRate': json['discountRate'] == null ? undefined : json['discountRate'],
        'length': json['length'] == null ? undefined : json['length'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        'weight': json['weight'] == null ? undefined : json['weight'],
        'disabled': json['disabled'] == null ? undefined : json['disabled'],
    };
}

export function UpdateProductDtoToJSON(value?: UpdateProductDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'sku': value['sku'],
        'nameAr': value['nameAr'],
        'nameEn': value['nameEn'],
        'descriptionAr': value['descriptionAr'],
        'descriptionEn': value['descriptionEn'],
        'imageUrls': value['imageUrls'],
        'inStock': value['inStock'],
        'brandCode': value['brandCode'],
        'categoryCode': value['categoryCode'],
        'subBrandCode': value['subBrandCode'],
        'subCategoryCode': value['subCategoryCode'],
        'barcode': value['barcode'],
        'prices': value['prices'],
        'taxRate': value['taxRate'],
        'discountRate': value['discountRate'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
        'weight': value['weight'],
        'disabled': value['disabled'],
    };
}

